import BookingComponent from "../../Components/Booking/Booking"

export function BookingView(){
    return(
        <div><BookingComponent/></div>
    )
}